export const backendHost = process.env.BACKEND_URL || 'https://api.cloud.ru';

export const gtmId = 'GTM-KLNL8NV';
export const ymId = process.env.NEXT_PUBLIC_YM_ID || '75066511';
export const testYmId = '93605518';
